import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface TabBarBoneProps {
    /** Nombre d'onglets */
    tabsCount?: number;
    /** Hauteur des onglets */
    tabHeight?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const TabBarBone: React.FunctionComponent<TabBarBoneProps> = function ({
    tabsCount = 3,
    tabHeight = '48px',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                width: '100%',
                gap: 1,
                ...sx,
            }}
        >
            {Array.from({ length: tabsCount }).map((_, index) => (
                <BoxBone
                    key={`tab-${tabsCount}-${index + 1}`}
                    sx={{
                        height: tabHeight,
                        width: `${60 / tabsCount}%`,
                        borderRadius: '4px',
                    }}
                />
            ))}
        </Box>
    );
};
